import React, { Suspense, useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { Provider } from './components/ui/provider';
import { Box } from '@chakra-ui/react';
import { Sidebar, sidebarWidth } from 'components/ui/Sidebar';
import ProtectedRoute from 'components/ProtectedRoute';
import 'components/axiosConfig'; 

import SearchPage from './Pages/SearchPage';
import HomePage from './Pages/HomePage';
import JobsOverviewPage from './Pages/JobsOverviewPage';
import ResultsPage from './Pages/ResultsPage';
import IngestOverviewPage from './Pages/IngestOverviewPage';
import GenerateReportsPage from './Pages/GenerateReportsPage';
import HelpPage from './Pages/HelpPage';
import LoginPage from './Pages/LoginPage';
import PageNotFoud from './Pages/404Page';
import UserManagementPage from './Pages/UserManagementPage';
import SamplesOverviewPage from 'Pages/SamplesOverviewPage';
import SamplePage from 'Pages/SamplePage';
import CDSPage from 'Pages/CDSPage';
import ContigPage from 'Pages/ContigPage';

function AppContent() {
  return (
    <Box display="flex">
      <Sidebar />
      <Box 
        ml={sidebarWidth}
        w={`calc(100% - ${sidebarWidth})`} 
        p="3em"
        maxWidth="60em"
      >
        <Routes>
          <Route path="/login" element={<LoginPage />} />

          <Route path="/" element={
            <ProtectedRoute>
              <Navigate to="/search" replace />
            </ProtectedRoute>
          } />
          {/* <Route path="/" element={<Navigate to="/search" replace />} /> */}

          <Route path="/search" element={<ProtectedRoute><SearchPage /></ProtectedRoute>} />
          <Route path="/search_results" element={<ProtectedRoute><JobsOverviewPage /></ProtectedRoute>} />
          <Route path="/ingestion_status" element={<ProtectedRoute><IngestOverviewPage /></ProtectedRoute>} />
          <Route path="/results/:jobId" element={<ProtectedRoute><ResultsPage /></ProtectedRoute>} />
          <Route path="/help" element={<ProtectedRoute><HelpPage /></ProtectedRoute>} />
          <Route path="/generate_reports" element={<ProtectedRoute><GenerateReportsPage /></ProtectedRoute>} />
          <Route path="/user_management" element={<ProtectedRoute><UserManagementPage /></ProtectedRoute>} />
          <Route path="/samples" element={<ProtectedRoute><SamplesOverviewPage /></ProtectedRoute>} />
          <Route path="/samples/:sampleId" element={<ProtectedRoute><SamplePage /></ProtectedRoute>} />
          <Route path="/cds/:cdsId" element={<ProtectedRoute><CDSPage /></ProtectedRoute>} />
          <Route path="/contig/:recordId" element={<ProtectedRoute><ContigPage /></ProtectedRoute>} />
          <Route path="/contig/:recordId/:start/:end" element={<ProtectedRoute><ContigPage /></ProtectedRoute>} />
          <Route path="*" element={<PageNotFoud />} />
        </Routes>
      </Box>
    </Box>
  );
}

function App() {
  return (
    <Provider>
      <Router>
        <AppContent />
      </Router>
    </Provider>
  );
}

export default App;
